import { gql } from "@apollo/client"
export const ADD_CUSTOMFIELD = gql(`
 mutation AddCustomField($input: AddCustomFieldInput!){
   addCustomField (input:$input){
     __typename
   }
}
`)